import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaWhatsapp, FaInstagram, FaYoutube, FaTwitter, FaTiktok } from 'react-icons/fa';

const FooterComponent = () => {
  return (
    <footer className="bg-dark text-white py-4">
      <Container>
        <Row>
          {/* Left Section */}
          <Col md={6}>
            {/* <h4 style={{ color: '#FF7C24', fontWeight: 'bold', fontSize: '24px' }}>Fintorro</h4> */}
            {/* <p style={{ fontSize: '14px' }}>Learn While Looking for Opportunities!</p>
            <p>&copy; 2025 Designed & Built by FinTorro Team.</p> */}

            {/* Social Media Links */}
            {/* <div className="d-flex mt-3">
              <a href="https://api.whatsapp.com/message/4RKX5CK6X7AZG1?autoload=1&app_absent=0" className="me-3" aria-label="WhatsApp">
                <FaWhatsapp size={24} color="#25D366" />
              </a>
              <a href="https://www.instagram.com/fintorro_/" className="me-3" aria-label="Instagram">
                <FaInstagram size={24} color="#C13584" />
              </a>
              <a href="https://www.youtube.com/channel/UCpyXK7z3r5QIxkAECKaVsHQ" className="me-3" aria-label="YouTube">
                <FaYoutube size={24} color="red" />
              </a>
              <a href="https://x.com/fintorro_" className="me-3" aria-label="Twitter">
                <FaTwitter size={24} color="#1DA1F2" />
              </a>
              <a href="https://www.tiktok.com/@fintorro" aria-label="TikTok">
                <FaTiktok size={24} color="black" />
              </a>
            </div> */}
          </Col>

          {/* Right Section */}
          {/* <Col md={6}>
            <a href="https://www.fintorro.com/mobile/" className="text-white d-block mb-2">
              Products (Mobile Apps, Blogs)
            </a>
            <a href="https://www.fintorro.com/privacy-policy/" className="text-white d-block">
              Company (Terms, Privacy Policy, Cookies Policy)
            </a>
          </Col> */}
        </Row>

        {/* Bottom Text */}
        {/* <Row className="text-center mt-4">
          <Col>
            <p>&copy; 2025 Designed & Built by FinTorro Team.</p>
          </Col>
        </Row> */}
      </Container>
    </footer>
  );
};

export default FooterComponent;
